Controller.$inject = ['$scope', '$timeout'];

function Controller($scope, $timeout) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }

        if (self.showArrows) {
            self.inputFocused = true;
        }
    };

    self.handleBlur = () => {
        if (!self.ngModel && self.labelVariant !== 'outlined') {
            self.showLegend = false;
        }
        self.inputFocused = false;
    };

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        })
    }

    $scope.$on('datePickerInputFocused', function(event) {
        self.handleFocus();
    });

    $scope.$on('datePickerInputBlured', function(event) {
        self.handleBlur();
    });
}

export function HuiInputDatePicker() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            datePickerBootstrap: '<',
            dateFormat: '@',
            defaultDate: '=?',
            startDate: '=',
            endDate: '=',
            showIcon: '<',
            onChange: '&',
            fullWidth: '<',
            startWeek: '<?',
            hidePopup: '<?',
            placement: '@?',
            showArrows: '<?',
            allowTyping: '<?',
            bsDatepickerStartView: '<?',
            disabledDates: '=?',
            disabledEvents: '=?',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon'
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                model-value="$huiCtrl.ngModel"
                disabled="$huiCtrl.disabled"
                full-width="$huiCtrl.fullWidth"
                with-icon-start="$huiCtrl.showIcon && $huiCtrl.showArrows"
                >
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
               <hui-input-base-icon ng-transclude ng-transclude-slot="icon"></hui-input-base-icon>
               <date-picker 
                    ng-class="{'w-100': $huiCtrl.fullWidth}"
                    name="{{$huiCtrl.hName}}"
                    date-picker-bootstrap="$huiCtrl.datePickerBootstrap"
                    ng-disabled="$huiCtrl.disabled"
                    ng-attr-date-format="{{$huiCtrl.dateFormat}}"
                    placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder  : ''}}"
                    default-date="$huiCtrl.defaultDate"
                    start-date="$huiCtrl.startDate"
                    start-week="$huiCtrl.startWeek"
                    end-date="$huiCtrl.endDate"
                    ng-model="$huiCtrl.ngModel"
                    show-icon="$huiCtrl.showIcon"
                    allow-typing="$huiCtrl.allowTyping"
                    ng-focus="$huiCtrl.handleFocus()"
                    ng-blur="$huiCtrl.handleBlur()"
                    hide-popup="$huiCtrl.hidePopup"
                    placement="{{$huiCtrl.placement}}"
                    show-arrows="$huiCtrl.showArrows"
                    ng-change="$huiCtrl.handleChange($event)"
                    disabled-dates="$huiCtrl.disabledDates"
                    disabled-events="$huiCtrl.disabledEvents"
                    ng-attr-bs-datepicker-start-view="{{$huiCtrl.bsDatepickerStartView}}"
                    >
               </date-picker>
              </hui-input-base>
             `;
        }
    }
}


